module.exports = __webpack_public_path__ + "img/cooperate_banner.406f248a.png";